import DownloadPdfComponent from "../DownloadPdfComponent/DownloadPdfComponent";
import "./ModalComponent.scss";
import PropTypes from "prop-types";
import imgNotAvailible from '../../assests/img_not_availible.png';
import globals from "../../config/appconfig";

/**
 * @function ModalComponent Modal components
 * @param idModale id type of the Modal Component
 * @returns {JSX.Element}
 */
const ModalComponent = ({ idModale, title, src, alt, actionBtn, allegato, openModal, setOpenModal }) => {

    return (
        <>
            <div className="ModalContainer">
                <div className={`${(openModal) ? "modal-backdrop fade show" : ""}`}></div>
                <div  className={`${(openModal) ? "modal fade show" : ""}`}  tabIndex="-1" role="document" id={idModale}>
                    <div className="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-xl" role="document">
                        <div className="modal-content">
                            <div className="modal-header row">
                                <div className="col-12 col-lg-8 modal__title">
                                    <span className="modal-title" id="exampleModalTitle" role="contentinfo" tabIndex="0" aria-label={title}>{title}</span>
                                </div>
                                <div className="col-12 col-lg-3 mt-lg-0 mt-2 modal__button--download text-lg-end text-start">
                                    <DownloadPdfComponent classBtn={`${!(allegato) ? "primary disabled" : "primary"}`} actionBtn={() => actionBtn()} pdf="false"></DownloadPdfComponent>
                                </div>
                                <div className="modal__button--close" onClick={() => { setOpenModal() }}>
                                    <span className="material-icons-outlined" style={{ fontSize: "24px" }} type="button" tabIndex="0" aria-label={"close"}>close</span>
                                </div>
                            </div>
                            <div className="modal-body text-center pb-4" role="contentinfo" tabIndex="0">
                                <img
                                    src={`${globals["app-url-bucket"]}${src}`}
                                    title={title}
                                    alt={alt}
                                    width={"100%"}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

ModalComponent.propTypes = {
    idModale: PropTypes.string.isRequired,
    title: PropTypes.string,
    src: PropTypes.string,
    alt: PropTypes.string
};

ModalComponent.defaultProps = {
    idModale: "",
    title: "",
    src: imgNotAvailible,
    alt: "immagine non disponibile"
};

export default ModalComponent;